// @flow
import moment from 'moment'

export function roundDate(d: Object):Object {

    const diff = d.minutes() % 5;
    let ret = 0;
    if (diff >= 3) {
        //round up
        ret = moment(d).add(5 - diff, 'm')

    } else {
        // round down
        ret = moment(d).add(-diff, 'm')

    }
    return ret;
}